import GlobalDivider from '@/utils/divider/GlobalDivider';
import { Button, Drawer } from 'antd';
import DrawerSettings from './componets/DrawerSettings';
import ShortCutSettings from './componets/ShortCutSettings';
import HelpComponents from './componets/HelpComponents';

const DashboardDrawer = ({
  drawerType,
  visible,
  onClose,
  passwordVisible,
  onCancel,
  shortcuts,
}) => {
  const renderContent = () => {
    switch (drawerType) {
      case 'help':
        return (
          <div>
            <HelpComponents />
          </div>
        );
      case 'settings':
        return (
          <DrawerSettings
            passwordVisible={passwordVisible}
            onCancel={onCancel}
            onClose={onClose}
          />
        );
      case 'shortcuts':
        return <ShortCutSettings onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={onClose}
      open={visible}
      width={500}
    >
      {renderContent()}
    </Drawer>
  );
};

export default DashboardDrawer;
